module.exports = __webpack_public_path__ + "static/media/home3.3fc5c0b0.png";